var _path, _path2, _circle, _circle2, _circle3, _circle4, _circle5, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVideo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    "data-name": "Layer 1",
    viewBox: "0 0 64 64",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48,46H12a6.0066,6.0066,0,0,1-6-6V24a6.0066,6.0066,0,0,1,6-6H44a1,1,0,0,1,0,2H12a4.0042,4.0042,0,0,0-4,4V40a4.0042,4.0042,0,0,0,4,4H48a4.0042,4.0042,0,0,0,4-4V28a1,1,0,0,1,2,0V40A6.0066,6.0066,0,0,1,48,46Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36 32a1.0137 1.0137 0 0 1-.4.8l-8 6a.99.99 0 0 1-1.05.09A.988.988 0 0 1 26 38V26a1.0022 1.0022 0 0 1 1.6-.8l8 6A1.0137 1.0137 0 0 1 36 32zM59 19a1.0029 1.0029 0 0 1-1 1 3.9989 3.9989 0 0 0-4 4 1 1 0 0 1-2 0 3.9989 3.9989 0 0 0-4-4 1 1 0 0 1 0-2 3.9989 3.9989 0 0 0 4-4 1 1 0 0 1 2 0 3.9989 3.9989 0 0 0 4 4A1.0029 1.0029 0 0 1 59 19z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 10,
    r: 1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 59,
    cy: 30,
    r: 1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 53,
    r: 1
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 53,
    r: 4
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 53,
    r: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.09 52H14a1 1 0 0 0 0 2h7.09M32.91 54H52a1 1 0 0 0 0-2H32.91"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.45fca19e.svg";
export { ForwardRef as ReactComponent };